import { useDispatch } from 'react-redux';
import { fetchCmsContent } from '../redux/manageCms/actionCreator';
import HttpStatus from '../utility/status.enum';

export const useCMS = () => {
  const dispatch = useDispatch();

  const fetchCMSCommonFunction = async (actionType, otherData = {}) => {
    try {
      const formdata = {
        action_type: actionType,
      };
      // Extra data in CMS
      if (Object.keys(otherData).length > 0) {
        Object.assign(formdata, otherData);
      }
      const response = await dispatch(fetchCmsContent(formdata));
      return response?.result?.description || '';
    } catch (error) {
      console.error('Error fetching CMS content:', error);
      return '';
    }
  };

  return { fetchCMSCommonFunction };
};
